
(function() {
    try {
        // 1. Cấu hình các ID của offer muốn chặn truy cập trang detail sản phẩm quà tặng
        var RESTRICTED_OFFER_IDS = ["23217"]; 

        // Kiểm tra xem có đang ở trang product detail không
        var isProductPage = window.location.pathname.indexOf('/products/') !== -1;
        if (!isProductPage) return;

        function getNonGlobalId(id) {
            if (!id) return "";
            return String(id).split("/").pop();
        }

        // 2. Xác định Product ID hiện tại
        var currentProductId = null;
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
            currentProductId = String(window.ShopifyAnalytics.meta.product.id);
        } else if (window.meta && window.meta.product) {
            currentProductId = String(window.meta.product.id);
        } else if (window.tlFreeGiftData && window.tlFreeGiftData.currentProduct) {
            currentProductId = String(window.tlFreeGiftData.currentProduct.id);
        }

        if (!currentProductId) return;
        var currentProductIdNorm = getNonGlobalId(currentProductId);

        // Lấy danh sách các Collection ID mà sản phẩm này thuộc về
        var currentCollections = [];
        if (window.tlFreeGiftData && window.tlFreeGiftData.currentProduct && window.tlFreeGiftData.currentProduct.collections) {
            currentCollections = window.tlFreeGiftData.currentProduct.collections.map(getNonGlobalId);
        }

        // Hàm thực hiện kiểm tra và redirect
        function checkAndRedirect(rules) {
            if (!rules || !rules.length) return;

            var shouldRedirect = rules.some(function(rule) {
                if (RESTRICTED_OFFER_IDS.indexOf(String(rule.id)) === -1) {
                    return false;
                }

                return rule.listChilds && rule.listChilds.some(function(child) {
                    var childProdId = getNonGlobalId(child.product_id);
                    var childShopifyId = getNonGlobalId(child.shopify_id);

                    if (childProdId === currentProductIdNorm || childShopifyId === currentProductIdNorm) {
                        return true;
                    }

                    if (currentCollections.length > 0 && currentCollections.indexOf(childShopifyId) !== -1) {
                        return true;
                    }

                    return false;
                });
            });

            if (shouldRedirect) {
                window.location.href = "/";
            }
        }

        var shopName = window.Shopify && window.Shopify.shop ? window.Shopify.shop : "";
        var storageKey = "tl-free-gift-local-storage-" + shopName;
        var localDataStr = null;
        
        try {
            localDataStr = localStorage.getItem(storageKey);
        } catch (storageErr) {
        }
        
        if (localDataStr) {
            try {
                var localData = JSON.parse(localDataStr);
                if (localData && localData.rules) {
                    checkAndRedirect(localData.rules);
                    return;
                }
            } catch (jsonErr) {
            }
        }

        var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
        var proxyUrl = rootPath + "apps/salepify/free-gift/basic";
        proxyUrl = proxyUrl.replace(/\/+/g, '/'); 
        
        fetch(proxyUrl)
            .then(function(res) { 
                if (!res.ok) throw new Error("Network response not ok");
                return res.json(); 
            })
            .then(function(resData) {
                if (resData && resData.success && resData.data) {
                    checkAndRedirect(resData.data);
                }
            })
            .catch(function(err) {
            });

    } catch (globalErr) {
        console.warn("Salepify Custom Redirect Error ignored:", globalErr.message);
    }
})();
